var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001246",
    d: "M10 0c1.105 0 2 .895 2 2 0 .701-.36 1.318-.907 1.675C12.491 4.133 13.5 5.45 13.5 7c0 .276-.224.5-.5.5s-.5-.224-.5-.5c0-1.38-1.12-2.5-2.5-2.5S7.5 5.62 7.5 7c0 .245-.177.45-.41.492L7 7.5c-.276 0-.5-.224-.5-.5 0-1.38-1.12-2.5-2.5-2.5S1.5 5.62 1.5 7c0 .276-.224.5-.5.5S.5 7.276.5 7c0-1.551 1.01-2.867 2.407-3.326C2.36 3.318 2 2.701 2 2c0-1.105.895-2 2-2s2 .895 2 2c0 .701-.36 1.318-.907 1.675.804.263 1.479.81 1.907 1.522.428-.712 1.103-1.259 1.907-1.523C8.36 3.318 8 2.701 8 2c0-1.105.895-2 2-2zM4 1c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1zm6 0c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.c8ce2dc55f431dabf108f404f66a69ce.svg";
export { ForwardRef as ReactComponent };